import { Component, Input } from '@angular/core'

@Component({
    selector: 'mg-referral-celebration-popup',
    templateUrl: './referral-celebration-popup.component.html',
    styleUrls: ['./referral-celebration-popup.component.scss'],
})
export class ReferralCelebrationPopupComponent {
    @Input() referralCode: string
}
